import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

Modal.setAppElement("#root");

export default function Create_expense() {
  const title = "Add Expenses";
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [category, setCategory] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  const [formData, setFormData] = useState({
    id_user: "",
    date: null,
    id_hub: "",
    id_expenseCategory: "",
    amount: "",
    comments: "",
    id_vehicle: "",
    transactionType: "credit",
    attachment: [],
  });

  const [errors, setErrors] = useState({});

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };
    fetchVehicles();
  }, []);
  const handleVehicleChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_vehicle: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUsers(response.data.users);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setHubs(response.data.hubs);
      } catch (error) {
        console.error("Error fetching hubs:", error);
        setHubs([]);
      }
    };
    fetchHubs();
  }, []);
  const handleHubChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_hub: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/expense-categories`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setCategory(response.data.expenseCategories);
      } catch (error) {
        console.error("Error fetching expenseCategories:", error);
        setCategory([]);
      }
    };
    fetchCategory();
  }, []);
  const handleCategoryChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_expenseCategory: selectedOption ? selectedOption.value : "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.id_user) {
      newErrors.id_user = "User ID is required.";
    }
    if (!formData.amount) {
      newErrors.amount = "Amount is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;

    // Handle multiple attachments
    if (name === "attachment") {
      const selectedFiles = Array.from(files || []);

      // Optional: 10 MB per file
      const maxFileSize = 10 * 1024 * 1024;

      const oversizedFiles = selectedFiles.filter(
        (file) => file.size > maxFileSize,
      );

      if (oversizedFiles.length > 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          attachment: "Each attachment must not exceed 10MB.",
        }));

        return;
      }

      setErrors((prevErrors) => ({
        ...prevErrors,
        attachment: "",
      }));

      setFormData((prevFormData) => ({
        ...prevFormData,
        attachment: selectedFiles,
      }));

      return;
    }

    // Handle normal fields
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selectedOption ? selectedOption.value : "",
    }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;
    if (errors.attachment) {
      alert(errors.attachment);
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) return;

    const formPayload = new FormData();

    formPayload.append("id_user", formData.id_user);
    formPayload.append("date", formData.date);
    formPayload.append("id_hub", formData.id_hub);
    formPayload.append("id_expenseCategory", formData.id_expenseCategory);
    formPayload.append("amount", formData.amount);
    formPayload.append("comments", formData.comments);
    formPayload.append("transactionType", formData.transactionType);

    // ✅ Only append vehicle if selected
    if (formData.id_vehicle) {
      formPayload.append("id_vehicle", formData.id_vehicle);
    }

    if (formData.attachment?.length) {
      formData.attachment.forEach((file) => {
        formPayload.append("attachment", file);
      });
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/expense/new`,
        formPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 201) {
        navigate("/expense");
      }
    } catch (error) {
      console.error(error.response ? error.response.data : error);
    }
  };

  const handleAttachmentAdd = (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const maxFileSize = 10 * 1024 * 1024; // 10 MB

    if (file.size > maxFileSize) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachment: "Each attachment must not exceed 10MB.",
      }));

      event.target.value = "";
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      attachment: "",
    }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      attachment: [...(prevFormData.attachment || []), file],
    }));

    // Allows selecting the same file again if needed
    event.target.value = "";
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="id_user">
                  <b>User Name *</b>
                </label>
                <Select
                  name="id_user"
                  options={users.map((user) => ({
                    value: user._id,
                    label: `${user.name || "Unknown Name"} (${
                      user.phonenumber || "Unknown Phone"
                    })`,
                  }))}
                  onChange={handleSelectChange}
                  classNamePrefix="select"
                />
                {errors.id_user && (
                  <div className="invalid-feedback">{errors.id_user}</div>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="id_vehicle">
                  <b>Vehicle </b>
                </label>
                <Select
                  name="id_vehicle"
                  options={vehicles.map((vehicle) => ({
                    value: vehicle._id,
                    label: `${vehicle.numberplate}`,
                  }))}
                  onChange={(selectedOption) =>
                    handleVehicleChange(selectedOption)
                  }
                  classNamePrefix="select"
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="id_hub">
                  <b>Assign Hub *</b>
                </label>
                <Select
                  name="id_hub"
                  options={hubs.map((hub) => ({
                    value: hub._id,
                    label: `${hub.name}`,
                  }))}
                  onChange={handleHubChange} // Use the specific handler
                  classNamePrefix="select"
                />
                {errors.id_hub && (
                  <div className="invalid-feedback">{errors.id_hub}</div>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="id_expenseCategory">
                  <b>Assign Category *</b>
                </label>
                <Select
                  name="id_expenseCategory"
                  options={category.map((category) => ({
                    value: category._id,
                    label: `${category.name}`,
                  }))}
                  onChange={handleCategoryChange} // Use the specific handler
                  classNamePrefix="select"
                />
                {errors.id_expenseCategory && (
                  <div className="invalid-feedback">
                    {errors.id_expenseCategory}
                  </div>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="amount">
                  <b>Amount *</b>
                </label>
                <input
                  type="number"
                  placeholder="Amount"
                  className="form-control"
                  name="amount"
                  onChange={onChangeHandler}
                  value={formData.amount || ""}
                />
                {errors.amount && (
                  <p className="text-danger">{errors.amount}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="date">
                  <b>Date *</b>
                </label>
                <input
                  type="date"
                  name="date"
                  onChange={onChangeHandler}
                  className="form-control"
                  value={formData.date || ""}
                />
                {errors.joiningDate && (
                  <p className="text-danger">{errors.date}</p>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="transactionType">
                  <b> Driver Transaction Type *</b>
                </label>
                <select
                  name="transactionType"
                  className="form-control"
                  value={formData.transactionType || ""}
                  onChange={onChangeHandler}
                >
                  <option value="credit">Credit</option>
                  <option value="debit">Debit</option>
                </select>
              </div>

              <div className="col-md-6 mt-2">
                <label>
                  <b>Attachments</b>
                </label>

                <div className="d-flex align-items-center gap-2">
                  <input
                    id="attachmentInput"
                    type="file"
                    className="d-none"
                    onChange={handleAttachmentAdd}
                  />

                  <label
                    htmlFor="attachmentInput"
                    className="btn btn-outline-primary btn-sm mb-0"
                    style={{ cursor: "pointer" }}
                  >
                    + Add Attachment
                  </label>
                </div>

                {formData.attachment?.length > 0 && (
                  <div className="mt-2">
                    {formData.attachment.map((file, index) => (
                      <div
                        key={`${file.name}-${index}`}
                        className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                      >
                        <div>
                          <span>{file.name}</span>

                          <small className="text-muted d-block">
                            {(file.size / 1024 / 1024).toFixed(2)} MB
                          </small>
                        </div>

                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => {
                            setFormData((prevFormData) => ({
                              ...prevFormData,
                              attachment: prevFormData.attachment.filter(
                                (_, i) => i !== index,
                              ),
                            }));
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {errors.attachment && (
                  <p className="text-danger mt-1">{errors.attachment}</p>
                )}
              </div>

              <div className="col-md-6 mt-3"></div>
              <div className="col-12 mt-3">
                <label htmlFor="comments">
                  <b>Comments</b>
                </label>
                <textarea
                  name="comments"
                  type="text"
                  placeholder="Enter Comment"
                  rows="5"
                  className="form-control"
                  value={formData.comments}
                  onChange={onChangeHandler}
                ></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Expense
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
